import type { ReactNode } from 'react';

interface TrialDecorationLayoutProps {
  children: ReactNode;
}

export default function TrialDecorationLayout({ children }: TrialDecorationLayoutProps) {
  return (
    <div className="relative flex min-h-screen w-full flex-col items-stretch gap-2 overflow-hidden bg-gradient-to-b from-[rgba(129,139,154,0.89)] to-[#F4F6F9]">
      {/* 背景装飾画像 */}
      <div className="pointer-events-none absolute inset-0 size-full">
        <img
          src="/agent/trial/decoration-background.svg"
          alt=""
          className="size-full object-cover"
        />
      </div>

      {/* コンテンツエリア */}
      <div className="h-full">{children}</div>
    </div>
  );
}
